<template>
    <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData" :isAllegati="true" :isMateriali="false">
        <template slot="tab-content-event">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-button v-if="jsonData.id !== null" size="sm" variant="outline-info outline-primary-noborder sa-margin-right float-sm-right" @click="onClickReferta" class="mb-2">
                        <i class="far fa-edit"></i>
                        Referta
                    </b-button>
                    <print-component v-if="jsonData.id !== null && !anamnesiFirmata" :jsonData="jsonData" :linkPrintData="linkPrintData" :firmaGrafometrica="true" :codiceApplicativo="codiceApplicativoBotox" :idAnagrafica="idPaziente" nomeCampo="Firma" nomeFile="Anamnesi_Botox_" descrizione="Anamnesi Botox" tipoDocumento="ANAMNESI BOTOX" class="float-sm-right mb-2" @afterSign="onFirmaUpdate"></print-component>
                </b-col>
            </b-row>
            <anamnesi-botox-edit-component :jsonData="jsonData" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></anamnesi-botox-edit-component>
        </template>
    </eventi-edit-component>
</template>
<script>
import axios from "axios";
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import PrintComponent from "../../../../../utility/components/PrintComponent.vue";
import AnamnesiBotoxEditComponent from "../components/AnamnesiBotoxEditComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    mixins: [UtilityMixin],
    components: { EventiEditComponent, AnamnesiBotoxEditComponent, PrintComponent },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
        },
        // anamnesiFirmata() {
        //     return this.jsonData.firma === "FIRMATO";
        // },
        linkPrintData() {
            return this.jsonData.id !== null ? "/anamnesibotox/print/" + this.jsonData.id : null;
        },
    },
    mounted() {
        let me = this;
        this.jsonData.dataEvento = new Date().getTime();
        me.id = this.$route.params.id;
        if (me.id !== "-1") {
            this.loadData();
        }
    },
    data() {
        return {
            linkback: null,
            titoloEvento: "Anamnesi Botox",
            pathResource: "/anamnesibotox",
            pathRestValidation: "/validation",
            codiceApplicativoBotox: "BOTOX-ANAMNESI",
            id: "-1",
            isFirmato: false,
            childKey: 0,
            tabIndex: 0,
            showModalLoading: false,
            anamnesiFirmata: false,
            jsonData: {
                id: null,
                dataEvento: new Date().getTime(),
                fonteDati: "",
                fonteDatiAltro: "",
                allergie: "",
                allergieAltro: "",
                fumo: "",
                malattieAutoimmuni: "",
                malattieAutoimmuniNote: "",
                assunzioneFarmaci: "",
                assunzioneFarmaciNote: "",
                interventiChirurgici: "",
                interventiChirurgiciNote: "",
                precedentiTrattamentiMedicinaEstetica: "",
                precedentiTrattamentiMedicinaEsteticaNote: "",
                motivoVisita: "",
                esameObiettivoLocale: "",
                farmaci: "",
            },
        };
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        loadData() {
            let me = this;
            if (me.id === "-1") {
                return;
            }
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;

                    me.loadDataAllegati(me.jsonData.id);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onClickReferta() {
            if (!this.anamnesiFirmata) {
                return;
            }
            this.$router.push("/paziente/botox/visita/edit/-1?idPaziente=" + this.idPaziente);
        },
        loadDataAllegati(idRisorsa) {
            let path = "/allegati";
            this.loadDataResources(path, { idRisorsa: idRisorsa }, this.resultAllegatiResponse, null);
        },
        resultAllegatiResponse(response) {
            let listaAllegati = response.data.data;
            this.anamnesiFirmata = listaAllegati.some((allegato) => allegato.statoFirma === "FIRMATO");
        },
    },
};
</script>
